import React, { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AppWrapper } from "./AppWrapper";
import "./App.css";
import { installDeviceInterceptor } from "./device/deviceAxios";
import "bootstrap/dist/css/bootstrap.min.css";

// On a paired event-day device every API call goes to the device API
// (device/deviceAxios.js); installed before anything can make a request.
installDeviceInterceptor();

// The side-stage tablet (live stage display Phase 3) is its own small page:
// no login, no app chrome, no session handling, loaded only on /stage.
const StageCheckIn = lazy(() => import("./Stage/StageCheckIn"));
export const isStagePath = (path) => /^\/stage\/?$/.test(path || "");
// Pairing an event-day job device (card 540f21a4): its own small page too.
const DevicePair = lazy(() => import("./device/DevicePair"));
export const isDevicePairPath = (path) => /^\/device\/?$/.test(path || "");

function App() {
  if (isStagePath(window.location.pathname)) {
    return (
      <Suspense fallback={null}>
        <StageCheckIn />
      </Suspense>
    );
  }
  if (isDevicePairPath(window.location.pathname)) {
    return (
      <Suspense fallback={null}>
        <DevicePair />
      </Suspense>
    );
  }

  return (
    <Provider store={store}>
      <AppWrapper />
    </Provider>

  );
}

export default App;
